export { createShortcutManager } from "./manager.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/shortcuts/index.mjs
// module id = 1603
// module chunks = 1